import createInstance from "./instance";
import { refreshTokens, fetchTokens } from "./tokens";
import { AuthSvc } from ".";

const authSvc: AuthSvc = {
  createInstance,
  refreshTokens,
  fetchTokens,
};

export default authSvc;

export * from "./instance";
export * from "./schemas";
